import { Link } from "react-router-dom";

export default function SchulungenFooter() {
  return (
    <footer className="bg-slate-900 text-white py-8" data-testid="schulungen-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center">
        <p className="text-sm text-slate-400">&copy; {new Date().getFullYear()} Lehnen & Weinacht — Pflegeberatung & Alltagsbegleitung · Anerkannter Schulungsträger</p>
        <div className="flex flex-wrap justify-center gap-4 sm:gap-6 mt-3 text-sm text-slate-500">
          <Link to="/" className="hover:text-white transition-colors">Startseite</Link>
          <Link to="/schulungen" className="hover:text-white transition-colors">Schulungen</Link>
          <Link to="/schulungen/firmenregistrierung" className="hover:text-white transition-colors">Firma registrieren</Link>
          <Link to="/schulungen/login" className="hover:text-white transition-colors">Login</Link>
          <Link to="/blog" className="hover:text-white transition-colors">Ratgeber</Link>
        </div>
      </div>
    </footer>
  );
}
